import React from 'react'
import FishToWhiteTransition from '../../utils/FishToWhiteTransition';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Link } from "react-router-dom";
import withContext from "../../withContext";
import eyehead from '../pages/IMG_0187.JPG';
import bear from '../pages/V6QVC6e.jpeg';
import octopus from '../pages/Relaxing_bath.webp';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

SwiperCore.use([Pagination]);

const STYLES = {
  sectionSpacing: { marginBottom: '8rem' },
  sectionTitle: { fontWeight: 400, fontSize: '2em', fontFamily: 'Playfair Display, serif' },
  bodyText: { fontSize: '1.4em', lineHeight: '1.5', fontWeight: 400, marginBottom: '2.5rem' },
  smallBodyText: { fontSize: '1em', fontWeight: 400 },
  primaryButton: { backgroundColor: '#C9A45C', color: 'white', border: 'none', padding: '0.75rem 1.875rem', fontSize: '1.1em' },
  smallPrimaryButton: { backgroundColor: '#C9A45C', color: 'white', border: 'none', padding: '0.5rem 1.5rem', fontSize: '1em' },
  grayBox: { backgroundColor: '#f8f9fa', padding: '2.5rem', textAlign: 'center' },
  formInput: { padding: '0.5rem 0.75rem', fontSize: '1em' },
  productName: { marginBottom: '0.25rem', fontSize: '1.0em', fontWeight: 400 },
  productPrice: { marginBottom: '0', fontSize: '1.0em', fontWeight: 400 }
};

class HomePage extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      fadeIn: false,
      subscribeName: '',
      subscribeEmail: '',
      subscribeStatus: null,
      subscribeLoading: false,
      contactName: '',
      contactEmail: '',
      contactTopic: '',
      contactMessage: '',
      contactAgree: false,
      contactStatus: null,
      contactLoading: false
    };
  }

  importAll(r) {
    let images = {};
    r.keys().forEach((item) => {
        images[item.replace('./', '')] = r(item);
    });
    return images;
  }

  images = this.importAll(require.context('../header/images', false, /\.(png|jpe?g|svg|webp)$/));
  imagesMobile = this.importAll(require.context('../header/imagesMobile', false, /\.(png|jpe?g|svg|webp)$/));
  reviewImages = this.importAll(require.context('./reviewPhotos', false, /\.(png|jpe?g|svg|jpg|JPG)$/));

  isPortrait() {
    return window.innerHeight > window.innerWidth;
  }

  isMobile() {
    return window.innerWidth <= 768;
  }
  
  componentDidMount() {
    this.props.context.refresh();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    setTimeout(() => this.setState({ fadeIn: true }), 50);
    
    // If coming from another page, scroll to reviews
    if (window.__needsReviewsScroll) {
      window.__needsReviewsScroll = false;
      const reviewsSection = document.getElementById('reviews-section');
      if (reviewsSection) {
        const rect = reviewsSection.getBoundingClientRect();
        const scrollTop = window.pageYOffset + rect.top - 80;
        window.scrollTo({ top: scrollTop, behavior: 'smooth' });
      }
    }
  }

  componentWillUnmount() {
    // Cleanup if needed
  }

  render(){
    return (
      <div>
        {/*  Section 0: - Fish Bike */}
        <div className="HomePageImageContainer">
          {this.isPortrait() === false || window.screen.width >= 769 ? (
            this.images['00-fish-bike.webp'] && (
              <img
                className="HomePageImage"
                src={this.images['00-fish-bike.webp'].default}
                alt="Header"
              />
            )
          ) : (
            this.imagesMobile['00-fish-bike.webp'] && (
              <img
                className="HomePageImage"
                src={this.imagesMobile['00-fish-bike.webp'].default}
                alt="Header"
              />
            )
          )}
          {/* SVG Curved Overlay for smooth transition below 100vh */}
          <FishToWhiteTransition />
          <svg
            className="HomePageImageOverlaySVG"
            style={{
              position: 'absolute',
              top: '100vh',
              left: 0,
              width: '100%',
              height: '12vh',
              zIndex: 2,
              pointerEvents: 'none',
              display: 'block'
            }}
            viewBox="0 0 100 12"
            preserveAspectRatio="none"
          >
            <defs>
              <linearGradient id="whiteFade" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="rgba(255,255,255,0)" />
                <stop offset="100%" stopColor="rgba(255,255,255,1)" />
              </linearGradient>
            </defs>
            <path d="M0,0 Q50,12 100,0 L100,12 L0,12 Z" fill="url(#whiteFade)" />
          </svg>
        </div>

        <Container className="homepage-content mb-4" style={{marginTop: STYLES.sectionSpacing.marginBottom}}>
        {/* Section 1: Latest Shop Updates */}
        <Row className="mb-4" style={STYLES.sectionSpacing}>
          <Col>
            <h2 className="text-left" style={{...STYLES.sectionTitle, marginBottom: '2.5rem'}}>Latest shop updates</h2>
            <div className="latest-shop-updates d-flex justify-content-between" style={{gap: '2rem', flexWrap: 'wrap'}}>
              {this.props.context.products && this.props.context.products.length > 0 &&
                this.props.context.products
                  .filter(product => ['Section1', 'Section2'].includes(product.type))
                  .slice(0, 3)
                  .map((product, idx) => (
                    <div key={product.id || idx} className="latest-product-item" style={{flex: '1 1 calc(33.333% - 1.4rem)', minWidth: '15.625rem', textAlign: 'center'}}>
                      <img src={product.URLp} alt={product.name} style={{width: '100%', aspectRatio: '1', objectFit: 'cover', marginBottom: '1rem'}} />
                      <h4 style={STYLES.productName}>{product.name}</h4>
                      <p style={STYLES.productPrice}>{product.price}&euro;</p>
                    </div>
                  ))
              }
            </div>
            <div className="text-right mt-5">
              <Link to="/shop">
                <Button style={STYLES.primaryButton}>
                  View All
                </Button>
              </Link>
            </div>
          </Col>
        </Row>


        {/* Section 2: Meet the Artist */}
        <Row>
          <Col>
            <h2 className="text-left" style={{...STYLES.sectionTitle, marginTop: STYLES.sectionSpacing.marginBottom, marginBottom: '2.5rem'}}>Meet the Artist</h2>
          </Col>
        </Row>
        <Row className="align-items-center" style={STYLES.sectionSpacing}>
          <Col md={6}>
            <img
              className="w-100"
              src={eyehead}
              alt="Kate the artist"
            />
          </Col>
          <Col md={6}>
            <p style={STYLES.bodyText}>
              Hi, I'm Katya Zhmud - an artist from Siberia living in the Netherlands.            </p>
            <p style={STYLES.bodyText}>  
              My work spans across various mediums and materials, always pushing boundaries and exploring 
              the unexpected. I love creating pieces that make people smile, think, and question reality.
            </p>
          </Col>
        </Row>

        {/* Section 3: Salvador Dali Quote (single instance, full width) */}
        <Row style={{...STYLES.sectionSpacing, marginLeft: 0, marginRight: 0, width: '100vw', position: 'relative', left: '50%', right: '50%', transform: 'translateX(-50%)'}}>
          <Col className="text-center" style={{padding: 0}}>
            <div style={{...STYLES.grayBox, borderRadius: 0, margin: 0}}>
              <blockquote style={{
                ...STYLES.sectionTitle,
                margin: '2.5rem 0',
                background: 'none',
                border: 'none',
                padding: 0
              }}>
                "What is important is to spread confusion, not eliminate it"
                <footer style={{fontSize: '0.6em', marginTop: '1.25rem'}}>- Salvador Dalí</footer>
              </blockquote>
            </div>
          </Col>
        </Row>

        {/* Section 4: Available Paintings */}
        <Row className="align-items-center" style={STYLES.sectionSpacing}>
          <Col md={6}>
            {/* <h2 style={{fontWeight: 400, fontSize: '2em'}}>Available Paintings</h2> */}
            <p style={{...STYLES.bodyText, marginBottom: '1.5rem'}}>
            Since 2017, I've created and sold over 60 original paintings, along with many prints that now bring joy and color to homes around the world. 
            </p>
            <p style={{...STYLES.bodyText, marginBottom: '2rem'}}>
            Some of my artworks find their new owners the very same day I release them—so if one speaks to you, don't wait too long. 
            </p>            
            <Link to="/shop">
              <Button style={STYLES.primaryButton}>
                Available Paintings
              </Button>
            </Link>
          </Col>
          <Col md={6}>
            <img
              className="w-100"
              src={octopus}
              alt="Available paintings"
            />
          </Col>
        </Row>

        {/* Section 5: Join Mailing List */}
        <Row style={{...STYLES.sectionSpacing, marginLeft: 0, marginRight: 0, width: '100vw', position: 'relative', left: '50%', right: '50%', transform: 'translateX(-50%)'}}>
          <Col style={{padding: 0}}>
            <div style={{...STYLES.grayBox, borderRadius: 0, margin: 0}}>
              <div style={{maxWidth: '1100px', margin: '0 auto'}}>
              <h2 className="mb-3" style={STYLES.sectionTitle}>Join My Mailing List</h2>
              <p style={{...STYLES.smallBodyText, marginBottom: '1.875rem'}}>  
                Stay updated with my latest artwork, exhibitions, and exclusive offers. 
                Be the first to know about new pieces and special events!
              </p>
              <Form onSubmit={(e)=>{ e.preventDefault(); }}>
                <Row className="justify-content-center align-items-center" style={{gap: '1rem'}}>
                  <Col xs={12} md={3} lg={3} className="p-0">
                    <Form.Group className="mb-0">
                      <Form.Control 
                        type="text" 
                        placeholder="Name" 
                        value={this.state.subscribeName}
                        onChange={(e)=> this.setState({ subscribeName: e.target.value, subscribeStatus: null })}
                        style={STYLES.formInput}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={3} lg={3} className="p-0">
                    <Form.Group className="mb-0">
                      <Form.Control 
                        type="email" 
                        placeholder="Email" 
                        value={this.state.subscribeEmail}
                        onChange={(e)=> this.setState({ subscribeEmail: e.target.value, subscribeStatus: null })}
                        style={STYLES.formInput}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={3} lg={2} className="p-0">
                    <Button
                      type="button"
                      disabled={this.state.subscribeLoading}
                      onClick={async ()=>{
                        const name = this.state.subscribeName.trim();
                        const email = this.state.subscribeEmail.trim();
                        if(!name || !email){
                          return this.setState({ subscribeStatus: { variant: 'danger', message: 'Please fill in both name and email.' } });
                        }
                        const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if(!emailRe.test(email)){
                          return this.setState({ subscribeStatus: { variant: 'danger', message: 'Invalid email format.' } });
                        }
                        this.setState({ subscribeLoading: true });
                        try {
                          const res = await fetch('/subscribe', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ name, email })
                          });
                          const data = await res.json().catch(()=>({ message: 'Unexpected response' }));
                          if(res.status === 201){
                            this.setState({ subscribeStatus: { variant: 'success', message: 'Thank you for subscribing!' }, subscribeName: '', subscribeEmail: '' });
                          } else if (res.status === 200) {
                            this.setState({ subscribeStatus: { variant: 'info', message: data.message || 'You are already subscribed.' } });
                          } else if (res.status === 400){
                            this.setState({ subscribeStatus: { variant: 'warning', message: data.message || 'Validation error.' } });
                          } else {
                            this.setState({ subscribeStatus: { variant: 'danger', message: data.message || 'Server error. Try later.' } });
                          }
                        } catch(err){
                          this.setState({ subscribeStatus: { variant: 'danger', message: 'Network error. Please retry.' } });
                        } finally {
                          this.setState({ subscribeLoading: false });
                        }
                      }}
                      style={{...STYLES.smallPrimaryButton, width: '100%'}}
                    >
                      { this.state.subscribeLoading ? 'Submitting...' : 'Subscribe' }
                    </Button>
                  </Col>
                </Row>
                { this.state.subscribeStatus && (
                  <div style={{ marginTop: '1.125rem', fontSize: '0.95em' }} className={`text-${this.state.subscribeStatus.variant}`}>
                    {this.state.subscribeStatus.message}
                  </div>
                )}
              </Form>
            </div>
            </div>
          </Col>
        </Row>

        {/* Section 6: Commissions */}
        <Row className="align-items-center" style={STYLES.sectionSpacing}>
          <Col md={6}>
            <img
              className="w-100"
              src={bear}
              alt="Commission artwork"
            />
          </Col>
          <Col md={6}>
            <h2 style={{...STYLES.sectionTitle, marginBottom: '1.5rem'}}>Commissions</h2>
            <p style={{...STYLES.bodyText, marginBottom: '2rem'}}>
              Have a vision for a custom piece? I'd love to bring your ideas to life! 
              Whether it's a portrait, pet painting, or something completely unique, 
              let's create something magical together.
            </p>
            <Button 
              style={STYLES.primaryButton}
              onClick={() => {
                const contactSection = document.getElementById('contact-section');
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Get Quote
            </Button>
          </Col>
        </Row>

        {/* Section 7: Reviews */}
        <div id="reviews-section" style={{...STYLES.sectionSpacing, width: '100vw', marginLeft: 'calc(-50vw + 50%)', marginRight: 'calc(-50vw + 50%)'}}>
          <h2 className="text-center" style={{...STYLES.sectionTitle, marginBottom: '3rem'}}>What people say</h2>
          <Swiper
            grabCursor={true}
            loop={true}
            slidesPerView={'auto'}
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: true,
            }}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              320: {
                slidesPerView: 'auto',
                spaceBetween: 10
              },
              768: {
                slidesPerView: 'auto',
                spaceBetween: 20
              },
              1024: {
                slidesPerView: 'auto',
                spaceBetween: 30
              }
            }}
            className="reviews-swiper"
          >
            {Object.values(this.reviewImages).map((img, idx) => (
              <SwiperSlide key={idx}>
                <img src={img.default} alt={`Review ${idx + 1}`} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Section 8: Contact Form */}
        <Row id="contact-section" style={{...STYLES.sectionSpacing, marginLeft: 0, marginRight: 0, width: '100vw', position: 'relative', left: '50%', right: '50%', transform: 'translateX(-50%)'}}>
          <Col style={{padding: 0}}>
            <div style={{...STYLES.grayBox, padding: '2.5rem 2.5rem 3rem 2.5rem', margin: 0, borderRadius: 0, textAlign: 'left'}}>
              <div style={{maxWidth: '1100px', margin: '0 auto'}}>
              <h2 className="mb-3 text-center" style={STYLES.sectionTitle}>Get In Touch</h2>
              <p style={STYLES.smallBodyText} className="text-center">
                Have a question about a painting, a commission idea, prints, or just want to say hello? I’d love to hear from you.
              </p>
              <Form onSubmit={(e)=>{ e.preventDefault(); }}>
                <Row className="g-3 justify-content-center">
                  <Col md={5}>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        placeholder="Name"
                        value={this.state.contactName}
                        onChange={(e)=> this.setState({ contactName: e.target.value, contactStatus: null })}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group>
                      <Form.Control
                        type="email"
                        placeholder="Email"
                        value={this.state.contactEmail}
                        onChange={(e)=> this.setState({ contactEmail: e.target.value, contactStatus: null })}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        placeholder="Topic"
                        value={this.state.contactTopic}
                        onChange={(e)=> this.setState({ contactTopic: e.target.value, contactStatus: null })}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Your message"
                        value={this.state.contactMessage}
                        onChange={(e)=> this.setState({ contactMessage: e.target.value, contactStatus: null })}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Check type="checkbox" id="contact-privacy" style={{display: 'flex', alignItems: 'center'}}>
                        <Form.Check.Input
                          checked={this.state.contactAgree}
                          onChange={(e)=> this.setState({ contactAgree: e.target.checked, contactStatus: null })}
                          style={{marginRight: '0.5rem', marginTop: '2px'}}
                        />
                        <Form.Check.Label style={{fontSize: '0.9em', margin: 0, lineHeight: '1.2'}}>
                          I agree with the website privacy policy.
                        </Form.Check.Label>
                      </Form.Check>
                    </Form.Group>
                  </Col>
                  <Col md={10} className="d-grid">
                    <Button
                      type="button"
                      disabled={this.state.contactLoading}
                      style={STYLES.smallPrimaryButton}
                      onClick={async ()=>{
                        const name = this.state.contactName.trim();
                        const email = this.state.contactEmail.trim().toLowerCase();
                        const topic = this.state.contactTopic.trim();
                        const message = this.state.contactMessage.trim();
                        if(!name || !email || !topic || !message){
                          return this.setState({ contactStatus: { variant: 'danger', message: 'Please fill in all fields.' } });
                        }
                        if(!this.state.contactAgree){
                          return this.setState({ contactStatus: { variant: 'warning', message: 'You must agree with the privacy policy.' } });
                        }
                        const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if(!emailRe.test(email)){
                          return this.setState({ contactStatus: { variant: 'danger', message: 'Invalid email format.' } });
                        }
                        this.setState({ contactLoading: true });
                        try {
                          // reuse existing backend route /newformarrived expecting data array [name,email,topic,message]
                          const payload = { data: [name, email, topic, message] };
                          const res = await fetch('/newformarrived', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(payload)
                          });
                          if(res.status === 201){
                            this.setState({ contactStatus: { variant: 'success', message: 'Message sent successfully!' }, contactName: '', contactEmail: '', contactTopic: '', contactMessage: '', contactAgree: false });
                          } else if (res.status === 429) {
                            this.setState({ contactStatus: { variant: 'warning', message: 'Too many attempts. Please wait and try again.' } });
                          } else if (res.status === 400) {
                            this.setState({ contactStatus: { variant: 'warning', message: 'Validation error.' } });
                          } else {
                            this.setState({ contactStatus: { variant: 'danger', message: 'Server error. Please try later.' } });
                          }
                        } catch(err){
                          this.setState({ contactStatus: { variant: 'danger', message: 'Network error. Please retry.' } });
                        } finally {
                          this.setState({ contactLoading: false });
                        }
                      }}
                    >
                      { this.state.contactLoading ? 'Sending...' : 'Send Message' }
                    </Button>
                  </Col>
                </Row>
                { this.state.contactStatus && (
                  <div style={{ marginTop: '1.125rem', fontSize: '0.95em' }} className={`text-${this.state.contactStatus.variant}`}>
                    {this.state.contactStatus.message}
                  </div>
                )}
              </Form>
            </div>
            </div>
          </Col>
        </Row>

      </Container>
      </div>
    );
  }
}

export default withContext(HomePage)